import './static/style/um.css';
import './static/style/animate.css';
// import './static/style/Icon.css';
import 'core-js/features/url-search-params/index';
import('./index');